import { ChangeDetectionStrategy, Component, inject } from "@angular/core";
import { FeatureBranchInfoService } from "src/app/modules/shared/components/feature-branch-banner/feature-branch-info.service";
import { FeatureBranchCookieService } from "src/app/modules/shared/components/feature-branch-banner/feature-branch-cookie.service";
import { ButtonModule } from "@storeblocks/button-ng";
import { FeatureEnvService } from "src/app/services/feature-env/feature-env.service";
import { CopyValueToClipboardService } from "src/app/services/copy-value-to-clipboard.service";

@Component({
  selector: "app-feature-branch-banner",
  imports: [ButtonModule],
  templateUrl: "./feature-branch-banner.component.html",
  styleUrl: "./feature-branch-banner.component.scss",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FeatureBranchBannerComponent {
  private readonly infoService = inject(FeatureBranchInfoService);
  private readonly cookieService = inject(FeatureBranchCookieService);
  private readonly featureEnvService = inject(FeatureEnvService);
  private readonly copyValueToClipboardService = inject(CopyValueToClipboardService);

  isFeatureBranch = false;
  currentRepo?: string;
  featureBranchName?: string;
  githubUrl?: string;

  constructor() {
    const info = this.infoService.getFeatureBranchInfo();
    this.isFeatureBranch = info.isFeatureBranch;
    this.currentRepo = info.currentRepo;
    this.featureBranchName = info.featureBranchName;

    if (this.currentRepo && this.featureBranchName) {
      this.githubUrl = `https://github.com/storebrand-digital/${this.currentRepo}/pulls?q=${this.featureBranchName}+in%3Acomments`;
    }
  }

  closeBanner(): void {
    this.cookieService.removeFeatureBranchCookie();
  }

  copyLink(): void {
    const link = this.featureEnvService.shareLink();
    if (!link) {
      return;
    }
    this.copyValueToClipboardService.copy(link, "Link copied");
  }
}
